<template>
  <treeselect
    v-model="valueTree"
    :no-results-text="$t('variables.noData')"
    :no-children-text="$t('variables.noData')"
    :multiple="false"
    :close-on-select="true"
    :disabled="false"
    :options="optionsTree"
    :searchable="true"
    placeholder=""
    @select="onSelect"
  />
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
export default {
  components: {
    Treeselect
  },
  props: {
    optionsTree: {
      type: Array,
      default: () => []
    },
    parentData: -1
  },
  data() {
    return {
      valueTree: null
    }
  },
  watch: {
    valueTree() {
      this.$emit('valueChange', this.valueTree)
    },
    parentData(value) {
      this.valueTree = value
    }
  },
  beforeCreate() {
    this.valueTree = null
  },
  mounted() {
    this.valueTree = this.parentData
  },
  destroyed() {
    this.valueTree = null
  },
  methods: {
    onSelect() {
      //
    }
    // searchChange(val) {
    //   setTimeout(() => {
    //     if (document.querySelector('.vue-treeselect__no-results-tip-text')) {
    //       document.querySelector(
    //         '.vue-treeselect__no-results-tip-text'
    //       ).innerHTML = this.$t('variables.noData')
    //     }
    //     if (
    //       document.querySelector(
    //         '.vue-treeselect__tip vue-treeselect__no-children-tip'
    //       )
    //     ) {
    //       document.querySelector(
    //         '.vue-treeselect__tip vue-treeselect__no-children-tip'
    //       ).style.background = 'red'
    //     }
    //   }, 50)
    // }
  }
}
</script>
